import { cn } from "@/lib/utils";

/** Inline entity tags truncate instead of stretching chat bubbles or the editor. */
export const TAG_MENTION_ENTITY_MAX_WIDTH_CLASS = "max-w-[min(240px,100%)]";

export const TAG_MENTION_USER_MAX_WIDTH_CLASS = "max-w-[min(180px,100%)]";

export const tagMentionEntityWrapperClassName = (extra?: string) =>
  cn(
    "tag-mention tag-mention-entity inline-flex min-w-0 align-middle",
    TAG_MENTION_ENTITY_MAX_WIDTH_CLASS,
    extra,
  );
